var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const TableRow = props => {
    const { children } = props, rest = __rest(props, ["children"]);
    return React.createElement("tr", Object.assign({}, rest), children);
};
export const TableCell = props => {
    const { children, className, variant = 'default', nowrap = true } = props, rest = __rest(props, ["children", "className", "variant", "nowrap"]);
    return (React.createElement("td", Object.assign({ className: clsx('px-6 py-4 ', nowrap && 'whitespace-nowrap', variant === 'text-primary' && 'text-basicSurface-900', variant === 'text-secondary' && 'text-basicSurface-500', className) }, rest), children));
};
//# sourceMappingURL=TableRow.js.map